import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["servicesSelect", "selectedList", "total"]
  static values = { updateUrl: String }
  
  connect() {
  }
  
  async servicesChanged(event) {
    setTimeout(async () => {
      const select = document.getElementById('dental_service_ids') || this.servicesSelectTarget
      if (!select) {
        return
      }
      
      const selectedIds = Array.from(select.selectedOptions).map(option => option.value)
      try {
        const response = await post(this.updateUrlValue, {
          body: JSON.stringify({ service_ids: selectedIds }),
          contentType: "application/json",
          responseKind: "turbo-stream"
        })
        
        if (response.ok) {
          setTimeout(() => {
            this.updateTotal()
          }, 100)
        }
      } catch (error) {
        console.error("Error al actualizar servicios:", error)
      }
    }, 100)
  }
  
  updateTotal() {
    let total = 0
    
    const rows = this.selectedListTarget.querySelectorAll('[data-service-id]')
    
    rows.forEach(row => {
      const quantityInput = row.querySelector('input[type="number"]')
      if (!quantityInput) return
      
      const price = parseFloat(quantityInput.dataset.price) || 0
      const quantity = parseInt(quantityInput.value) || 1
      const subtotal = price * quantity
      
      const subtotalElement = row.querySelector('[data-subtotal]')
      if (subtotalElement) {
        subtotalElement.textContent = `$${this.formatNumber(subtotal)}`
      }
      
      total += subtotal
    })
    
    if (this.hasTotalTarget) {
      this.totalTarget.textContent = `$${this.formatNumber(total)}`
    }
  }
  
  formatNumber(number) {
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
}
